import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { UserType } from '../models/user';
import { AccountService } from '../services/account.service';
import { environment } from 'src/environments/environment';

const approvedApi = `${environment.apiUrl}/api/`;

export const jwtInterceptor: HttpInterceptorFn = (request, next) => {
  const accountService = inject(AccountService);
  const router = inject(Router);

  if (!shouldAddCred(request)) {
    return next(request);
  }

  const requestWithCred = updateHeaders(request, accountService);

  return next(requestWithCred).pipe(
    catchError((error) => {
      if (!(error instanceof HttpErrorResponse) || error.status !== 401) {
        return throwError(() => error);
      }

      console.log('JwtInterceptor got 401');
      if (accountService.userType == UserType.PunchClockUser) {
        return accountService.refresh(accountService.tokenValue).pipe(
          switchMap(() => next(updateHeaders(request, accountService))),
          catchError((err) => {
            accountService.logout(router.url, true);
            return throwError(() => err);
          }),
        );
      }

      accountService.logout(router.url, true);
      return throwError(() => error);
    }),
  );
};

function updateHeaders(
  request: HttpRequest<unknown>,
  accountService: AccountService,
): HttpRequest<unknown> {
  const user = accountService.tokenValue;
  const isLoggedIn = user && user.token;

  if (isLoggedIn) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  console.log('JwtInterceptor did not set heders');
  return request;
}

function shouldAddCred(request: HttpRequest<unknown>): boolean {
  return request.url.startsWith(approvedApi);
}
